/// <reference path="../types/index.d.ts" />

import '../client_forms/aim/style.css';
import FormStructure from './aim/form_structure';

export default FormStructure;